import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Avaya() {
    return (
        <main className="relative overflow-hidden bg-gradient-to-b from-slate-900 to-black text-gray-100 pt-24 pb-20">
            <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-12">
                {/* -------- Text Section -------- */}
                <div className="flex-1 z-10">
                    <h1 className="text-4xl font-bold text-white">Avaya Orchestration Solutions</h1>
                    <p className="mt-4 text-lg text-gray-300 leading-relaxed">
                        SecureID Technologies provides contractor services for organizations running on the
                        Avaya Aura® platform. With expertise in Avaya Orchestration Designer (OD), we deliver
                        custom IVR flows, integrations, and optimizations to improve contact center performance.
                    </p>

                    <h2 className="mt-8 text-2xl font-semibold text-white">Key Features</h2>
                    <ul className="mt-3 list-disc pl-6 text-gray-300 space-y-2">
                        <li>Custom IVR and call flow design</li>
                        <li>Speech-enabled menus and natural language support</li>
                        <li>Web service and CTI integration</li>
                        <li>Reporting dashboards and monitoring</li>
                        <li>Performance tuning and optimization</li>
                    </ul>

                    <h2 className="mt-8 text-2xl font-semibold text-white">Use Cases</h2>
                    <p className="mt-3 text-gray-300 leading-relaxed">
                        Perfect for enterprises and government agencies using Avaya Aura® who need reliable
                        IVR enhancements, integrations with backend systems, or expert consulting on
                        call routing and customer experience improvements.
                    </p>

                    <p className="mt-10 text-center lg:text-left text-sm text-gray-400">
                        <Link to="/" className="text-indigo-400 hover:underline">
                            ← Back to Home
                        </Link>
                    </p>
                </div>

                {/* -------- Animated Image -------- */}
                <motion.div
                    className="flex-1 flex justify-center"
                    initial={{ opacity: 0, x: 150 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.1, ease: "easeOut" }}
                >
                    <img
                        src="/Images/ivrconcept.jpg"
                        alt="Avaya Orchestration Designer illustration"
                        className="w-[90%] max-w-md rounded-2xl shadow-2xl border border-gray-800"
                    />
                </motion.div>
            </section>
        </main>
    );
}
